import { render, staticRenderFns } from "./technologylist.vue?vue&type=template&id=2dbc9591&scoped=true&"
import script from "./technologylist.vue?vue&type=script&lang=js&"
export * from "./technologylist.vue?vue&type=script&lang=js&"
import style0 from "./technologylist.vue?vue&type=style&index=0&id=2dbc9591&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc9591",
  null
  
)

export default component.exports